module.exports = __webpack_public_path__ + "img/webex.83cea4a6.png";